import styled from 'styled-components';

export const MobileGift50BonusStyled = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100%;
    background-image: url('/assets/bonus/bonus-gift-50-bg.svg'), linear-gradient(180deg, #6971BB -30%, #131420 85%);
    background-position: top;
    background-size: 100%;
    background-repeat: no-repeat;
    
    @media (max-width: 412px) {
        background-size: 412px;
    }
`;

export const MobileGift50BonusContainerStyled = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 16px;
    flex-grow: 1;
    width: 100%;
    max-width: 450px;
    margin: 0 auto;
`;

export const MobileGift50BonusContentStyled = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 16px;
`;

export const MobileGift50BonusUntilParagraphStyled = styled.p`
    color: var(--text-color-secondary);
`;
